import React from "react";

const Mobilemenu = ({ mobilenavopen }) => {
  return (
    <div
      className="mobilemenu"
      style={mobilenavopen ? { display: "flex" } : { display: "none" }}
    >
      <p className="mobilenavitem">HOW WE WORK</p>
      <p className="mobilenavitem">BLOG</p>
      <p className="mobilenavitem">ACCOUNT</p>
      <p className="mobilenavitem">VIEW PLANS</p>
    </div>
  );
};

export default Mobilemenu;
